import { createBrowserHistory } from 'history'

/** Shared browser history — kept out of store/index to avoid saga↔store cycles. */
export const history = createBrowserHistory()
